import { Component } from '@angular/core';

@Component({
  selector: 'app-count-widget-skeleton',
  templateUrl: './count-widget-skeleton.component.html',
  styleUrls: ['./count-widget-skeleton.component.scss'],
})
export class CountWidgetSkeletonComponent {}
